<template>
  <div
    v-if="links"
    class="widget-best-selling-ies"
  >
    <z-title
      align="left"
      class="z-my-0000"
      color="minor"
      size="nano"
      tag="h2"
    >
      As melhores faculdades estão no Quero Bolsa
    </z-title>

    <z-link
      v-for="link in links"
      :key="link.url"
      :href="link.url"
      class="widget-best-selling-ies__link"
      tag="a"
    >
      <z-card
        class="widget-best-selling-ies__card"
        size="small"
      >
        <YLazyImage
          :alt="link.label"
          :src="link.logo"
          class="widget-best-selling-ies__logo"
        />
        <z-text
          align="center"
          class="widget-best-selling-ies__label"
          color="major"
          weight="medium"
        >
          {{ link.label }}
        </z-text>
      </z-card>
    </z-link>
  </div>
</template>

<script>
import { YLazyImage } from '@quero/yeti'

export default {
  name: 'WidgetBestSellingIes',
  components: {
    YLazyImage,
  },
  props: {
    links: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.widget-best-selling-ies {
  display: grid;
  row-gap: var(--unit-0400);
}

.widget-best-selling-ies__card {
  align-items: center;
  display: grid;
  justify-content: center;
}

.widget-best-selling-ies__label {
  margin-top: var(--unit-0400);
}

.widget-best-selling-ies__link {
  &:hover {
    text-decoration: none;
  }
}

.widget-best-selling-ies__logo {
  height: 90px;
  width: 160px;
  object-fit: contain;
}
</style>
